// import logo from '../assets/logo.png'

const IsLoading = () => {
  return (
    <div className="max-w-7xl mx-auto flex justify-center">
      {/* <img src={logo} alt="Loading" className='w-16 h-fit animate-spin opacity-80' /> */}

      <span className="loading loading-ring w-20 text-lightAqua" />
    </div>
  )
}

export default IsLoading